export default {
  "hierarchy": {
    "attributeBooleanEditor": [
      "toggle-attributeBooleanEditor"
    ],
    "attributeFormBooleanEditor": [
      "toggle-attributeBooleanEditor",
      "toggle-attributeFormBooleanEditor"
    ]
  },
  "props": {
    "default": {},
    "attributeBooleanEditor": {},
    "attributeFormBooleanEditor": {}
  }
}